import React from 'react';
import { Box, Typography } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';

const Footer: React.FC = () => {
  return (
    <Box 
      component="footer" 
      sx={{
        py: 2,
        textAlign: 'center',
        mt: 'auto',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)'
      }}
    >
      <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          gap: 0.5
        }}
      >
        Made with <FavoriteIcon sx={{ color: 'error.main', fontSize: '1rem' }} /> by Bentzy
      </Typography>
    </Box>
  );
};

export default Footer;